goog.provide("shadow.js.shim.module$src$svg$inform$info_circle_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$info_circle_svg");
shadow.js.shim.module$src$svg$inform$info_circle_svg = shadow.js.nativeProvides["src/svg/inform/info-circle.svg"] = shadow$bridge("src/svg/inform/info-circle.svg");
module$shadow_js_shim_module$src$svg$inform$info_circle_svg.default = shadow.js.shim.module$src$svg$inform$info_circle_svg;
